import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface OrgMember {
  user_id: string;
  email: string | null;
  full_name: string | null;
  role: string;
  permission_role: string;
  joined_at: string | null;
}

export function useOrgMembers(enabled = true) {
  return useQuery<OrgMember[]>({
    queryKey: ['org-members'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_org_members');
      if (error) throw error;
      return (data ?? []) as OrgMember[];
    },
    enabled,
  });
}
